<template>
  <div class="container text-left">
    <div class="row mt-4">
      <div class="col text-center">
        <h5>FAQs</h5>
        <div class="float-right">
          <button
            class="btn btn-link"
            data-toggle="modal"
            data-target="#createFAQModal"
            v-on:click="faqToEdit = null"
          >
            Add FAQ
          </button>
        </div>
      </div>
    </div>
    <div
      v-for="(faq, index) in faqs"
      :key="faq.FAQ_Id"
      class="row pt-2"
      v-bind:class="{ 'light-background': index % 2 === 1 }"
    >
      <div class="col-auto">
        <i
          class="material-icons d-block pointer mt-1"
          v-on:click="editFAQ(faq)"
        >
          edit
        </i>
      </div>
      <div class="col">
        <p class="mb-1">
          <b>{{ faq.Question }}</b>
        </p>
        <p>- {{ faq.Answer }}</p>
      </div>
    </div>
    <CreateFAQModal
      v-bind:FAQToEdit="faqToEdit"
      @editedFAQ="faqEdited"
      @addedFAQ="faqAdded"
      @deletedFAQ="faqDeleted"
    />
  </div>
</template>

<script>
import CreateFAQModal from "@/modals/FAQ/CreateFAQModal.vue";
import $ from "jquery";

export default {
  name: "Home",
  data() {
    return {
      faqs: [],
      faqToEdit: null
    };
  },
  components: {
    CreateFAQModal
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$data.faqs = await view.$getFAQs();
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    editFAQ(faq) {
      this.faqToEdit = faq;
      $("#createFAQModal").modal("show");
    },
    faqAdded(faq) {
      this.faqs.push(faq);
    },
    faqEdited(editedFAQ) {
      var editingIndex = this.faqs.findIndex(o => o.FAQ_Id == editedFAQ.FAQ_Id);
      this.$set(this.faqs, editingIndex, editedFAQ);
    },
    faqDeleted(faqId) {
      var deletedIndex = this.faqs.findIndex(o => o.FAQ_Id == faqId);
      this.faqs.splice(deletedIndex, 1);
    }
  }
};
</script>

<style></style>
